import { Button, ButtonProps, IconButton } from "@mui/material";
import { useStylesCss } from "./AppButtons.styles";

const AppIconButtonHeader: React.FC<ButtonProps> = (props: ButtonProps) => {
  const classes = useStylesCss();
  const myClasses = { ...classes.modalHeader, ...props.sx };
  const myProps = {
    ...props,
    sx: myClasses,
  };
  return (
    <IconButton variant="contained" {...myProps} color="primary">
      {props.children}
    </IconButton>
  );
};
export default AppIconButtonHeader;
